import { apiProvider } from './api';
import { NAME } from './constants';
import { router } from './router';

export const VerificationHistory = {
	name: NAME,
	apiProvider,
	router,
};
